import * as React from 'react';
import { Outside, TooltipDesktop } from '@cian/ui-kit';
import { SelectButton } from '../Select/SelectButton';

interface IFilterTooltipProps {
  buttonText: string;
  children: React.ReactNode;
  maxWidth?: number;
  dataTestId: string;
}

export const FilterTooltip: React.FC<IFilterTooltipProps> = ({ buttonText, children, maxWidth, dataTestId }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleToggle = React.useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  const handleClose = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  /**
   * Избыточная обертка нужна для корректной работы TooltipDesktop c Outside
   */
  return (
    <Outside onOutside={handleClose}>
      <div>
        <TooltipDesktop placement="bottom-start" portal={false} open={isOpen} theme="white" title={children}>
          <SelectButton
            text={buttonText}
            open={isOpen}
            onToggle={handleToggle}
            maxWidth={maxWidth}
            dataTestId={dataTestId}
          />
        </TooltipDesktop>
      </div>
    </Outside>
  );
};
